import apiService from "../common/commonApi";

export const allLeaveRequest = {};

allLeaveRequest.getAllLeaveRequest = async (param) => {
    return apiService.Get("getAllLeaveRequest", param);
};
